import { ROLS } from '../constants/rols.constant';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';

export const getOptionsMenu = (items) => {
	const user = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const isRol = user.admin === true ? ROLS.admin : ROLS.pharmacy;
	let filteredItems = items.filter((item) => {
		// Elimina el menu de páginas promocionales en caso de que sea usuario farmacia y marketplace, para ecommerce si se muestra
		if (!user.admin && !user.platform?.includes('ecommerce') && item.key === 'configuration-landing') {
			return false;
		}
		if (isRol.includes(item.key)) {
			if (item.children) {
				item.children = getOptionsMenu(item.children);
			}
			return true;
		}
		return false;
	});
	return filteredItems;
};

